const hexCodeRegexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i

export function hexToRgb (hex) {
  const result = /^#?([a-fA-F\d]{2})([a-fA-F\d]{2})([a-fA-F\d]{2})$/i.exec(hex)

  if (!result) {
    return null
  }

  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  }
}

export function getContrastFontColorByBackground (hexCode, darkColor = '#000000', lightColor = '#ffffff', defaultColor = '#000000') {
  const hexCodeCheckResult = hexCodeRegexp.exec(hexCode)

  if (!hexCodeCheckResult) {
    return defaultColor
  }

  const rgb = hexToRgb(hexCode)

  // http://www.w3.org/TR/AERT#color-contrast
  const threshold = Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) / 1000)

  return threshold > 125 ? darkColor : lightColor
}



// WEBPACK FOOTER //
// ./src/helpers/styles.js